module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full flex items-center gap-3",
    attrs: {
      "id": "filters"
    }
  }, [_c('div', {
    staticClass: "relative flex-1"
  }, [_c('i', {
    staticClass: "absolute left-3 top-1/2 -translate-y-1/2 inline-block h-5 w-5 mask mask-search bg-gray-400"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchingBar),
      expression: "searchingBar"
    }],
    staticClass: "w-full h-11 pl-10 pr-10 rounded-xl bg-[#E6EEF8] text-gray-700 placeholder-gray-400 outline-none\n             focus:ring-2 focus:ring-secondary focus:bg-white/90 transition",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholderFilter
    },
    domProps: {
      "value": (_vm.searchingBar)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchingBar = $event.target.value
      }, _vm.emitString]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-lg leading-none",
    attrs: {
      "type": "button",
      "aria-label": "Réinitialiser la recherche"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_vm._v("\n      ×\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb03418","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FilterBar.vue
// module id = 1028
// module chunks = 0